import Vue from 'vue';
import noop from 'lodash/noop';

export default {
  template: '<div></div>',
  bindings: {
    bid: '<'
  },
  controller: Ctrl,
}

Ctrl.$inject = ['$element'];
function Ctrl($element){
  const
    vm = this;

  let
    vueComponent = null;

  Object.assign(this, {

    $onInit () {
      import( /* webpackChunkName: 'TheHotelRateQuickBidForm' */ 'vRoot/rfp-hotel/bid/rate-quick/TheRateQuickQuestionnaireForm.vue')
        .then( imported => {
          vueComponent = new Vue({
            el: $element[0],
            render ( h ) {
              return h( imported.default, {
                props: {
                  bid: vm.bid,
                },
              });
            },
          });
        })
        .catch( noop );
    },

    $onDestroy () {
      if(vueComponent) {
        vueComponent.$destroy();
      }
    },
  });
}
